/**
 * What an outbound dial can carry (IC-70) — ONE rule, read by the trunk validator (R-TRK-4) and by the
 * LiveKit SIP dial (`packages/telephony/src/livekit/sip/dial.ts`), so a value the dial would refuse is
 * refused where the member wrote it, at its field, and never accepted with a 201 only to fail every dial
 * after it (integration verification M1 and ML1, 2026-09-30).
 *
 * - {@link SIP_WIRE_FORM_PATTERN}: the From or To user part of the INVITE. A wire number always fits
 *   (`+302101234567`, `00302101234567`, `2101234567`); an auth username presented as the caller ID
 *   (`account_name`) must fit too, so `@`, `:`, `;`, `%`, whitespace or more than 64 characters are
 *   refused at validation when that presentation is chosen.
 * - {@link SIP_DIAL_HOST_PATTERN}: a host name or an IPv4 literal — no scheme, no port, no parameters.
 *   An IPv6 literal does NOT fit: the SIP edge's dial does not support one yet, so the validator refuses
 *   it (`host_ipv6_unsupported`) instead of letting every dial through that trunk end `runtime_error`.
 */
/** A wire number or SIP user part: no `@`, no whitespace, no URI punctuation, 1–64 characters. */
export const SIP_WIRE_FORM_PATTERN = /^[A-Za-z0-9+*#._-]{1,64}$/;
/** A host name or IPv4 address; no scheme, no port, no parameters, no IPv6 literal (the dial's parser). */
export const SIP_DIAL_HOST_PATTERN = /^(?=.{1,253}$)[A-Za-z0-9](?:[A-Za-z0-9.-]*[A-Za-z0-9])?$/;
/** Whether `text` can be the From or To user of an outbound INVITE. */
export function isSipWireForm(text) {
    return SIP_WIRE_FORM_PATTERN.test(text);
}
/** Whether the dial can send an INVITE to `host`. */
export function isSipDialHost(host) {
    return SIP_DIAL_HOST_PATTERN.test(host);
}
//# sourceMappingURL=dial-shape.js.map